const data: any = {
  func: { loginHost: "https://passport.jd.com/new/login.aspx", apiHost: "//joshome.jd.com" },
  style: {},
  data: {},
  _clstag_: "jdzeus_powercenterlist_zeus_zeus_power_center_list",
};
export default data;
